/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
    constructor(
        private iconService: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {

        this.addIcon('employee', 'ico-employee.svg');
        this.addIcon('euro', 'ico-euro.svg');
        this.addIcon('planned', 'ico-planned.svg');
        this.addIcon('truck', 'ico-truck.svg');
    }

    private addIcon(name: string, svgFile: string): void {
        this.iconService.addSvgIcon(name, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/' + svgFile));
    }
}
